import join from 'url-join';
import http from '../../../util/http';
import { flatten } from '../../../util/array/flatten';

const api2 = join(import.meta.env.VITE_API2_URL, 'v1');

export const fetchAllLinkedEntities = async ({ entity, totalResources, sortQueryParams, filterQueryParams }) => {
  const url = join(api2, `${entity}/?count=100${sortQueryParams}${filterQueryParams}`);
  const numberOfRequests = Math.ceil(totalResources / 100);

  const subsequentRequests = [];
  let anchor = 0;
  /* eslint-disable no-await-in-loop */
  for (let i = 0; i < numberOfRequests; i += 6) {
    const subsequestRequestsGroup = [];
    const limit = Math.min(6, numberOfRequests - i);
    for (let j = 0; j < limit; j++) {
      subsequestRequestsGroup.push(http.get(`${url}&anchor=${anchor}`));
      anchor += 100;
    }

    await Promise.all(subsequestRequestsGroup)
      .then(responses => responses.map(r => r.data.objects))
      .then(result => subsequentRequests.push(flatten(result)));
  }
  return flatten(subsequentRequests);
};
